import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { appAxios } from 'api/axios';

// Define the structure of the state
interface TransactionState {
  transactions: any[];
  totalCount: number;
  loading: boolean;
  error: string | null;
}

// Initial state
const initialState: TransactionState = {
  transactions: [],
  totalCount: 0,
  loading: false,
  error: null,
};

// Thunk to fetch transactions with dynamic page and pageSize
export const fetchTransactions = createAsyncThunk(
  'transactions/fetchTransactions',
  async (
    {
      page,
      pageSize,
      status,
    }: { page: number; pageSize: number; status: string },
    { rejectWithValue }
  ) => {
    try {
      const response = await appAxios.post(
        `/get-all-transactions?page=${page}&pageSize=${pageSize}&status=${status}`
      );
      const totalCount = response.data.totalCount;
      console.log(totalCount);
      return { data: response.data.data, totalCount: totalCount };
    } catch (error: any) {
      return rejectWithValue(
        error.response?.data.message || 'Something went wrong'
      );
    }
  }
);

const transactionSlice = createSlice({
  name: 'transactions',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.transactions = action.payload.data;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default transactionSlice.reducer;
